/**
 * Hero with Image 50/50 block
 *
 * UI for handling the logic and animations of hero with image 50/50 block
 */

const $ = require( 'jquery' );

var itblHeroWithImage5050 = function(el){

  //setup some variables
  this.$el      = $(el);

  this.init();
};

itblHeroWithImage5050.prototype.init = function(){

  this.events();
  // this.positionImage();

};

itblHeroWithImage5050.prototype.events = function(){

  // No events for now
};

itblHeroWithImage5050.prototype.positionImage = function(){
    var viewportWidth = $(window).width();
    var containerWidth = this.$el.find('.itbl-hero-50-50__breadcrumbs').width();
    var halfDifference = (viewportWidth - containerWidth) / 2;

    // Move image to the right edge of the screen
    this.$el.find('.itbl-hero-50-50__container').css('margin-right', -1 * halfDifference);
}

$(function(){
  $('.itbl-hero-50-50').each(function(){
    new itblHeroWithImage5050(this);
  });
});
